import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getFormulariosList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetFormularios`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};


export { getFormulariosList }  